import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../../services/authentication.service';
import { GuardResult, MaybeAsync } from '@angular/router/router_module.d-BivBj8FC';

export const authenticationGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<GuardResult> => {
  const router = inject(Router);
  const authenticationService = inject(AuthenticationService);

  return new Observable<boolean>(observer => {
    if (isUserAllowed(authenticationService)) {
      if (authenticationService.tokenNeedsRefreshing()) {
        authenticationService.refreshAuthentication$()
          .subscribe({
            next: (): void => {
              if (isUserAllowed(authenticationService)) {
                observer.next(true);
                observer.complete();
              } else {
                authenticationService.setLastAttemptedUrl(state.url);
                router.navigate(['authentication']);
                observer.next(false);
                observer.complete();
              }
            },
          });
      } else {
        observer.next(true);
        observer.complete();
      }
    } else {

      authenticationService.setLastAttemptedUrl(state.url);
      router.navigate(['authentication']);

      observer.next(false);
      observer.complete();
    }
  });
};

function isUserAllowed(authenticationService: AuthenticationService): boolean {
  return authenticationService.isUserConnected();
}


